const formatPriceRM = (price: number) => {
    if (!price) return "RM0";
    const result = price.toLocaleString();
    return `RM${result}`;
  };
  export default formatPriceRM;
  